import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import { isHit99, isBet99ex, getCodeTheme, getBaseDomain, getResolvedApiBaseUrl, getSiteName, getDomainLogo } from './utils/domainConfig'
import { THEME_KEYS } from './config/siteThemes'

document.documentElement.setAttribute('data-brand', isHit99() ? 'hit99' : isBet99ex() ? 'bet99ex' : 'default')

// Theme: "Site Theme" page se domain-wise (backend AppUrl.theme). Pehle cache/code (flash na ho), phir backend se taaza.
const KNOWN_THEMES = THEME_KEYS
// data-theme = palette, data-skin = skin layout (default pe nahi)
const setTheme = (t) => {
  const root = document.documentElement
  root.setAttribute('data-theme', t)
  if (t && t !== 'default') root.setAttribute('data-skin', '')
  else root.removeAttribute('data-skin')
}
let cachedTheme = null
try { cachedTheme = localStorage.getItem('site_theme') } catch { /* ignore */ }
setTheme(KNOWN_THEMES.includes(cachedTheme) ? cachedTheme : getCodeTheme())
{
  const apiBase = getResolvedApiBaseUrl(import.meta.env.VITE_API_BASE_URL || '').replace(/\/$/, '')
  const ctrl = new AbortController()
  setTimeout(() => ctrl.abort(), 4000)
  fetch(`${apiBase}/api/appurls/theme?domain=${encodeURIComponent(getBaseDomain())}`, { signal: ctrl.signal })
    .then((r) => (r.ok ? r.json() : null))
    .then((d) => {
      const t = d?.theme
      if (!KNOWN_THEMES.includes(t)) return // backend me abhi field nahi -> code wali chalegi
      try { localStorage.setItem('site_theme', t) } catch { /* ignore */ }
      if (document.documentElement.getAttribute('data-theme') !== t) {
        setTheme(t)
        window.dispatchEvent(new Event('site-theme-change'))
      }
    })
    .catch(() => {})
}
document.title = `${getSiteName()} Admin`
const favicon = document.getElementById('favicon')
if (favicon) favicon.href = getDomainLogo()

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
